// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3Mx_e","item":"PaymentsMobile_item__1a1vy","label":"PaymentsMobile_label__oXNI9","amount":"PaymentsMobile_amount__1f_WP"};